import { Controller } from "stimulus";
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = ["submitBtn", "errorSubmitBtn", "cardBtn"];
  static values = { message: String };

  connect() {
    const resetThreadForm = document.querySelector('#reset-thread-form');
    const threadMessages = document.querySelectorAll('[data-test-ai-thread-message]');
    const resetThreadBtn = resetThreadForm.querySelector('button[type="submit"]');

    this.enableButtons = this.enableButtons.bind(this);

    if (resetThreadBtn && threadMessages.length === 0) {
      resetThreadBtn.disabled = true;
    }

    document.addEventListener("ai-assistant:enable-buttons", this.enableButtons);
  }

  disconnect() {
    document.removeEventListener("ai-assistant:enable-buttons", this.enableButtons);
  }

  sendPrompt(event) {
    this.target = event.currentTarget;
    this.prompt = this.target.dataset.prompt;

    if (this.prompt) {
      let path = this.target.dataset.path;

      const formData = new FormData();
      formData.append(
        'ai_assistants_new_form[rich_content]',
        this.prompt
      );

      Rails.ajax({
        url: path,
        type: "post",
        data: formData
      });
    }

    this.disableButtons();
  }

  handleDisableFromSubmit(event) {
    event.preventDefault();
    this.disableButtons();

    const form = document.querySelector('#js-assistant-form');

    // If there's a Trix editor, we want to trigger the cancel-changes
    // event to ensure that any unsaved changes are discarded.
    const trixEditor = form.querySelector('trix-editor');
    if (trixEditor) {
      document.dispatchEvent(new CustomEvent('promote:cancel-changes', {
        detail: { id: trixEditor.id }
      }));
    }
    const formData = new FormData(form);

    Rails.ajax({
      url: form.action,
      type: "post",
      data: formData
    });
  }

  disableButtons() {
    this.cardBtnTargets.forEach(card => {
      card.classList.add('pointer-events-none', 'opacity-50', 'bg-gray-200');
    });
    this.submitBtnTarget.disabled = true;
    if (this.errorSubmitBtnTarget) {
      this.errorSubmitBtnTarget.disabled = true;
    }
  }

  enableButtons() {
    this.cardBtnTargets.forEach(card => {
      card.classList.remove('pointer-events-none', 'opacity-50', 'bg-gray-200');
    });
    this.submitBtnTarget.disabled = false;
    if (this.errorSubmitBtnTarget) {
      this.errorSubmitBtnTarget.disabled = false;
    }

    this.enableResetThreadButton();
  }

  enableResetThreadButton() {
    const resetThreadForm = document.querySelector('#reset-thread-form');
    const threadMessages = document.querySelectorAll('[data-test-ai-thread-message]');
    const resetThreadBtn = resetThreadForm.querySelector('button[type="submit"]');

    if (resetThreadBtn && threadMessages.length > 0) {
      resetThreadBtn.disabled = false;
    }
  }
}
